
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProcessDetail from "../pages/process-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/process/:processId",
    element: <ProcessDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
